import React from 'react';
import {render} from 'react-dom';
import Doclite from 'doclite';
import pkg from 'doclite/package.json';
import {css, cx} from 'emotion';

const SRC = `import express from 'express';

// Create the app
const app = express();

/* Set up the initial route */
app.get('/', function (req, res) {
  res.send('Hello World');
});

/* Start the server! */
app.listen(3000);
`;

const codeDisplay = css({
  whiteSpace: 'pre',
  fontFamily: 'monospace',
});

const Syntax = {
  ImportSource: css({
    ':visited': {
      color: 'steelblue'
    }
  }),
  CommentLine: css({
    fontFamily: 'Georgia, serif',
    color: 'rgba(0, 0, 0, 0.4)',
    '::before': {
      content: '"//"',
    },
  }),
  CommentBlock: css({
    fontFamily: 'Georgia, serif',
    color: 'rgba(0, 0, 0, 0.4)',
    '::before': {
      content: '"/*"',
    },
    '::after': {
      content: '"*/"',
    },
  }),
  Identifier: css({
    fontStyle: 'italic',
    fontWeight: 'bold',
  }),
};

const textareaStyle = css({
  border: 'none',
  fontFamily: 'monospace',
  width: '100%',
  minHeight: '40rem',
});

class Demo extends React.Component {
  state = {
    children: null,
  }

  inputRef = null;

  handleRef = (ref) => {
    this.inputRef = ref;
    if (!ref) return;
    this.rerenderContent(ref.value);
  }

  handleUpdateClick = () => {
    if (!this.inputRef) return;
    this.rerenderContent(this.inputRef.value);
  }

  rerenderContent(textContent) {
    const tokens = Doclite.getTokens(textContent);
    this.setState({
      children: (
        <div className={cx('card-body', codeDisplay)}>
          {tokens.map(
            (
              {
                type,
                value,
                delimeters = [],
                startsLine = false,
                as: Component = 'span',
                props: {className, ...props} = {},
              },
              i
            ) => (
              <Component
                key={i}
                className={cx(Syntax[type], className, startsLine && 'starts-line')}
                {...props}
              >
                {value}
              </Component>
            )
          )}
        </div>
      )
    })
  }

  render() {
    return (
      <div className="container">
        <div className="p-3">
          <button type="button" className="btn btn-primary btn-block" onClick={this.handleUpdateClick}>
            Update
          </button>
        </div>
        <div className="row">
          <div className="col-sm">
            <div className="card">
              <textarea className={textareaStyle} defaultValue={SRC} ref={this.handleRef} />
            </div>
          </div>
          <div className="col-sm">
            <div className="card bg-light">
              {this.state.children}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const App = () => (
  <div className="container p-2">
    <h1>{pkg.name}</h1>
    <blockquote>{pkg.description}</blockquote>
    <div>
      <a className="p-1" href="https://www.npmjs.com/package/doclite">
        <img src="https://img.shields.io/npm/v/doclite.svg" alt={`npm version ${pkg.version}`} />
      </a>
      <a className="p-1" href="https://github.com/r24y/doclite/">
        <img src="https://img.shields.io/github/stars/r24y/doclite.svg?style=social&label=Stars" alt="GitHub" />
      </a>
    </div>
    <hr />
    <Demo />
  </div>
);

render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js